import React from 'react';
import styles from './AirdropSection.module.css';
import icNav from "../assets/icon/ic_nav.svg";
import havenLogoSmall from "../assets/icon/haven_logo_small.svg";
import havenLogo from "../assets/icon/haven_logo.svg";
import {useScreenDetector} from "../hooks/useScreenDetector";

const AirdropSection: React.FC = () => {

    const {isMobile} = useScreenDetector();
    return (
        <section className={styles.airdropSection}>
            <div className={styles.titleAndLogo}>
                <h1 className={styles.title}>Secure Your Haven1 Tokens Airdrop on Satoshi App</h1>
                <img
                    src={isMobile ? havenLogoSmall : havenLogo}
                    className={styles.aboutImage}
                />
            </div>
            <div className={styles.airdropContent}>

                    <span className={styles.description}>
          Thanks to the community support, the <strong>12 Million $H1 Tokens Airdrop</strong> concluded on Sep 28, 2024! If you participated, make sure to follow these steps to secure your tokens :
                        <br/><br/>
        </span>
                <span className={styles.description}>
          1. Register on <span
                    onClick={() => {
                        window.open('https://testnet.haven1.org/satoshiapp', '_blank');
                    }}
                    className={styles.link}>Haven1 Testnet</span> and connect your Web3 wallet.
        </span>
                <span className={styles.description}>
          2. Complete your KYC on Haven1 Testnet.
        </span>
                <span className={styles.description}>
                        3. Submit your linked <span
                    onClick={() => {
                        window.open('https://satoshiapp.xyz/en/download-app', '_blank');
                    }}
                    className={styles.link}>wallet address</span> on Satoshi App.
        </span>
                <br/>
                <p className={styles.deadline}>
                    Submission Deadline: <span className={styles.orange}>Nov 15, 2024, 2 PM (UTC+7)</span>
                </p>

                <div className={styles.readFull}
                     onClick={() => {
                         window.open('https://testnet.haven1.org/satoshiapp', '_blank');
                     }}>
                    <span className={styles.readFullText}>Read full guide here</span>
                    <img
                        src={icNav}
                        className={styles.readFullIcon}
                    />
                </div>

            </div>
        </section>
    )
        ;
};

export default AirdropSection;